module.exports = __webpack_public_path__ + "img/link-externo2.7ece7750.svg";